module.exports = __webpack_public_path__ + "static/media/no-data.2bbd272a.svg";